<template>
    <section :class="props.bgColor" class="py-10">
        <UContainer>
            <div class="flex flex-col items-center justify-center gap-8 md:grid md:grid-cols-2 lg:grid lg:grid-cols-2">
                <LandingCardHorizontal
                    to="/opportunities/plantation-ownership"
                    title="Plantation Ownership"
                    description="Aquilaria can grow on a wide range of soils, including poor sandy soil."
                    icon="i-lucide-trees"
                    iconColor="green"
                    color="blue" />

                <LandingCardHorizontal
                    to="/opportunities/agarwood-oil-and-chips"
                    title="Agarwood Oil & Chips"
                    description="Its rich scent and exotic associations have made it synonymous with oriental fragrances for centuries."
                    icon="i-carbon-soil-moisture-field"
                    iconColor="green"
                    color="blue" />
            </div>
        </UContainer>
    </section>
</template>

<script setup>
    const props = defineProps({
        bgColor: {
            type: String,
            default: 'bg-white dark:bg-gray-800',
            required: false
        }
    })
</script>
